import axios from "axios";
import { get, set } from "lodash";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const remapItem = item => ({ id: item["documentID"], ...item });
const remapItems = items => items.map(remapItem);

export const ACTION_TYPES = {
  FETCH_DOCUMENTS: "applicationDocuments/FETCH_DOCUMENTS",
  DOWNLOAD_DOCUMENT: "applicationDocuments/DOWNLOAD_DOCUMENT",
  UPLOAD_DOCUMENT: "applicationDocuments/UPLOAD_FILE",
  DELETE_DOCUMENT: "applicationDocuments/DELETE_FILE",
};

const initialState = {
  documents: [],
  loading: false,
};

export type ApplicationDocumentsState = Readonly<typeof initialState>;

/**
 * ApplicationDocuments Reducer
 */
export default (state: ApplicationDocumentsState = initialState, action): ApplicationDocumentsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.UPLOAD_DOCUMENT):
    case PENDING(ACTION_TYPES.FETCH_DOCUMENTS):
    case PENDING(ACTION_TYPES.DOWNLOAD_DOCUMENT): {
      return {
        ...state,
      };
    }

    case FULFILLED(ACTION_TYPES.DOWNLOAD_DOCUMENT): {
      return {
        ...state,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_DOCUMENTS): {
      return {
        ...state,
        documents: action.payload.data,
      };
    }

    case REJECTED(ACTION_TYPES.DOWNLOAD_DOCUMENT):
    case REJECTED(ACTION_TYPES.FETCH_DOCUMENTS): {
      return {
        ...state,
      };
    }

    case FULFILLED(ACTION_TYPES.UPLOAD_DOCUMENT): {
      return {
        ...state,
        loading: false,
      };
    }

    default: {
      return {
        ...state,
      };
    }
  }
};

/**
 * Actions for fetching documents data
 */

export const fetchAppDocuments = (appID: string) => {
  return {
    type: ACTION_TYPES.FETCH_DOCUMENTS,
    payload: axios.get(`applications/${appID}/documents`).then(response => {
      const items = get(response, "data", null);
      if (items) set(response, "data", remapItems(items));
      return response;
    }),
  };
};

/**
 * Actions for uploading documents data
 */

export const uploadAppDocument = (appID: string, file: any) => {
  const formData = new FormData();
  formData.append("FormFile", file);
  return {
    type: ACTION_TYPES.UPLOAD_DOCUMENT,
    payload: axios.post(`applications/${appID}/documents`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  };
};

/**
 * Actions for downloading documents data
 */

export const downloadAppDocument = (appID: string, documentID: string) => {
  return {
    type: ACTION_TYPES.DOWNLOAD_DOCUMENT,
    payload: axios.get(`applications/${appID}/documents/${documentID}`, { responseType: "blob" }),
  };
};

/**
 * Actions for deleting documents data
 */

export const deleteAppDocument = (appID: string, documentID: string) => {
  return {
    type: ACTION_TYPES.DELETE_DOCUMENT,
    payload: axios.delete(`applications/${appID}/documents/${documentID}`),
  };
};
